import { Table } from 'react-bootstrap';
import { useGetStoreStocksQuery } from '../../slices/storeStocksApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useMemo } from 'react';

const StoreStockUniqueDates = () => {
  const { data, isLoading, error } = useGetStoreStocksQuery();

  const storeStocks = useMemo(() => data?.storeStocks || [], [data]);

  const uniqueDates = useMemo(() => {
    return storeStocks.length > 0 
      ? [...new Set(storeStocks.map(storeStock => new Date(storeStock.date).toISOString().split('T')[0]))]
      : [];
  }, [storeStocks]);

  const sortedDates = useMemo(() => [...uniqueDates].sort((a, b) => new Date(a) - new Date(b)), [uniqueDates]);
  const date1 = sortedDates;
  
  return (
    <>
      <h1>Unique MiniStock Dates</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || 'Error fetching storeStock dates'}</Message>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            {date1.map((date, index) => (
              <tr key={index}>
                <td>{date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default StoreStockUniqueDates;
